var map = {
	"./accType.svg": "3acb",
	"./address.svg": "0e25",
	"./android.svg": "3dac",
	"./arrowDown.svg": "971d",
	"./bell.svg": "2fa4",
	"./country.svg": "6cc0",
	"./deposit.svg": "c44e",
	"./download.svg": "4dae",
	"./earth.svg": "b2f0",
	"./email.svg": "cbb7",
	"./error.svg": "b1b9",
	"./facebook.svg": "40e5",
	"./help.svg": "c932",
	"./income.svg": "9e25",
	"./info.svg": "4be3",
	"./instagram.svg": "a3c9",
	"./invest.svg": "fe86",
	"./ios.svg": "0842",
	"./language.svg": "2580",
	"./linked_in.svg": "022c",
	"./logo_star.svg": "2394",
	"./mac.svg": "7f2e",
	"./menu_close.svg": "a8ab",
	"./menu_fold.svg": "1b2d",
	"./menu_icon_account.svg": "2760",
	"./menu_icon_contact.svg": "28b6",
	"./menu_icon_funds.svg": "f4f3",
	"./menu_icon_home.svg": "cf85",
	"./menu_icon_promotion.svg": "7d23",
	"./menu_icon_register.svg": "d0d7",
	"./menu_icon_tool.svg": "64ae",
	"./menu_open.svg": "d0e3",
	"./menu_unfold.svg": "b3a2",
	"./mt4.svg": "e89f",
	"./name.svg": "0b38",
	"./notice.svg": "fc99",
	"./phone.svg": "dd82",
	"./success.svg": "a8cf",
	"./tiktok.svg": "1dd3",
	"./twitter.svg": "17e7",
	"./upload.svg": "9d82",
	"./warning.svg": "7e6f",
	"./windows.svg": "e1aea",
	"./youtube.svg": "35f1"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "51ff";